import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSliderSucceed, EGetSliderActionType } from './types';
import { ISlider } from '../../../types/slider';

export const getSliderSucceed: (data: ISlider) => TGetSliderSucceed = actionGenerator<
  EGetSliderActionType.Succeed,
  ISlider
>(EGetSliderActionType.Succeed);
